class SectionSwitchControls extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.pill-segmented-control__btn');
    
    // Bind event listeners
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => this.onButtonClick(e.currentTarget));
    });

    // Handle initial state after a small delay to ensure targets are in the DOM
    const activeBtn = this.querySelector('.active') || this.buttons[0];
    if (activeBtn) {
      setTimeout(() => {
        this.updateVisibility(activeBtn, true);
      }, 0);
    }
  }

  onButtonClick(clickedBtn) {
    if (clickedBtn.classList.contains('active')) return;

    // Toggle active classes
    this.buttons.forEach((btn) => btn.classList.remove('active'));
    clickedBtn.classList.add('active');

    this.updateVisibility(clickedBtn, false);
  }

  updateVisibility(activeBtn, isInitialLoad) {
    // 1. Gather all CSS selectors defined across all buttons
    let allSelectors = new Set();
    this.buttons.forEach((btn) => {
      const selectors = this.getSelectorsFromButton(btn);
      selectors.forEach((selector) => allSelectors.add(selector));
    });

    // 2. Hide all elements that match any of the selectors
    allSelectors.forEach((selector) => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          el.style.display = 'none';
        });
      } catch (e) {
        console.warn('Section Switch: Invalid CSS selector provided ->', selector);
      }
    });

    // 3. Show elements that match the active button's selectors
    const activeSelectors = this.getSelectorsFromButton(activeBtn);
    activeSelectors.forEach((selector) => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          // Revert to displaying normally
          el.style.display = ''; 
        });
      } catch (e) {
        // Warning already logged above
      }
    });
  }

  getSelectorsFromButton(btn) {
    const rawData = btn.getAttribute('data-target-selectors') || '';
    // Split by newlines or commas, trim spaces, remove empty strings
    return rawData.split(/[\n,]+/)
      .map(s => s.trim())
      .filter(s => s.length > 0);
  }
}

if (!customElements.get('section-switch-controls')) {
  customElements.define('section-switch-controls', SectionSwitchControls);
}
